var map = {
    "de-de": "de-de",
    "ar-sa": "ar-sa",
    "es-es": "es-es",
    "en-us": "en-us",
    "fr-fr": "fr-fr",
    "in-id": "in-id",
    "iw-il": "iw-il",
    "it-it": "it-it",
    "ko-kr": "ko-kr",
    "ja-jp": "ja-jp",
    "nl-nl": "nl-nl",
    "pt-pt": "pt-pt",
    "ru-ru": "ru-ru",
    "th-th": "th-th",
    "tr-tr": "tr-tr",
    "zh-cn": "zh-cn",
    "zh-tw": "zh-tw",
    "vi-vi": "vi-vn",
    "hindi": "hindi"
};
var i18n = {
    "de-de": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Beispiel",
                "commons.card.phone": "Telefon: ",
                "commons.card.tel": "Tel: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Fax"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ar-sa": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Example Example",
                "commons.card.phone": "Phone: ",
                "commons.card.tel": "Tel: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Fax"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "es-es": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Ejemplo Ejemplo",
                "commons.card.phone": "Teléfono: ",
                "commons.card.tel": "Tel: ",
                "commons.card.email": "Correo electrónico: ",
                "commons.card.fax": "Fax"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "en-us": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Example Example",
                "commons.card.phone": "Phone: ",
                "commons.card.tel": "Tel: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Fax"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "fr-fr": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Exemple Exemple",
                "commons.card.phone": "Téléphone: ",
                "commons.card.tel": "Tél.: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Fax: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "in-id": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Contoh",
                "commons.card.phone": "Telepon: ",
                "commons.card.tel": "Telepon: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Faksimile: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "iw-il": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Example Example",
                "commons.card.phone": "Phone: ",
                "commons.card.tel": "Tel: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Fax"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "it-it": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Esempio esempio",
                "commons.card.phone": "Cellulare: ",
                "commons.card.tel": "Tel: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Fax: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ko-kr": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "예시 예시",
                "commons.card.phone": "전화: ",
                "commons.card.tel": "전화: ",
                "commons.card.email": "이메일: ",
                "commons.card.fax": "팩스: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ja-jp": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "用例",
                "commons.card.phone": "携帯電話: ",
                "commons.card.tel": "電話番号: ",
                "commons.card.email": "メールアドレス: ",
                "commons.card.fax": "ファックス機: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "nl-nl": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Voorbeeld Voorbeeld",
                "commons.card.phone": "Telefoonnummer: ",
                "commons.card.tel": "Tel: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Fax: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "pt-pt": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Exemplo Exemplo",
                "commons.card.phone": "Tel: ",
                "commons.card.tel": "Tel: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Fax"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ru-ru": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Пример Пример",
                "commons.card.phone": "Телефон: ",
                "commons.card.tel": "Тел.: ",
                "commons.card.email": "Эл. почта: ",
                "commons.card.fax": "Факс: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "th-th": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "ตัวอย่าง ตัวอย่าง",
                "commons.card.phone": "มือถือ: ",
                "commons.card.tel": "โทรศัพท์: ",
                "commons.card.email": "อีเมล์: ",
                "commons.card.fax": "แฟกซ์: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "tr-tr": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Örnek Örnek ",
                "commons.card.phone": "Cep: ",
                "commons.card.tel": "Telefon: ",
                "commons.card.email": "E-Posta: ",
                "commons.card.fax": "Faks: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "zh-cn": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "示例",
                "commons.card.phone": "电话: ",
                "commons.card.tel": "手机: ",
                "commons.card.email": "邮箱: ",
                "commons.card.fax": "传真"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "zh-tw": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "示例",
                "commons.card.phone": "电话: ",
                "commons.card.tel": "手机: ",
                "commons.card.email": "邮箱: ",
                "commons.card.fax": "传真: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "vi-vn": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "Ví dụ",
                "commons.card.phone": "ĐT: ",
                "commons.card.tel": "ĐT: ",
                "commons.card.email": "E-mail: ",
                "commons.card.fax": "Số fax: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "hindi": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "commons.card.example": "उदाहरण उदाहरण",
                "commons.card.phone": "फ़ोन: ",
                "commons.card.tel": "टेलीफ़ोन: ",
                "commons.card.email": "ईमेल: ",
                "commons.card.fax": "फ़ैक्स: "
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })()
};

function _(locale) {
    var r = i18n[map[locale] || 'en-us'];
    r._ = _;
    return r;
}
try {
    var locale = seajs.data.vars.locale;
} catch (e) {
    var locale = 'en-us';
}
module.exports = _(locale);
